<div class="breadcrumb-area">
  <h1>Reporte de Recursos Humanos</h1>
</div>

<div
  class="card mb-3"
  id="humanResourcesAnnualReport"
  [appCheckPermission]="annualReport.permissions"
  [permissionType]="permissionType.ALL">

  <div
    class="title-report card-header d-flex justify-content-between align-items-center"
    (click)="selectedReport = selectedReport === 1 ? 0 : 1">

    <h3>{{ annualReport.name }}</h3>

    <h3>
      <i [ngClass]="selectedReport === 1 ? 'fa-minus' : 'fa-plus'" class="fa"></i>
    </h3>
  </div>

  <div class="card-body" *ngIf="selectedReport === 1">
    <div class="row">
      <div class="col-sm-10">
        <div class="form-group">
          <label for="yearHumanResources" class="form-label">Año:</label>

          <input
            type="number"
            [(ngModel)]="selectedYear"
            id="yearHumanResources"
            name="yearHumanResources"
            class="form-control"
            min="2000"
            max="2100">
        </div>
      </div>

      <div class="col-sm-2 download-buttons">
        <button
          [disabled]="annualReport.excel"
          (click)="getReport('excel', annualReport)"
          class="btn btn-success"
          data-bs-toggle="tooltip"
          title="Descargar Excel">

          <i *ngIf="!annualReport.excel" class="fa fa-file-excel"></i>

          <span
            *ngIf="annualReport.excel"
            class="spinner-border spinner-border-sm"
            aria-hidden="true">
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="card mb-3"
  id="humanResourcesMonthlyCompleteReport"
  [appCheckPermission]="monthlyCompleteReport.permissions"
  [permissionType]="permissionType.ALL">

  <div
    class="title-report card-header d-flex justify-content-between align-items-center"
    (click)="selectedReport = selectedReport === 2 ? 0 : 2">

    <h3>{{ monthlyCompleteReport.name }}</h3>

    <h3>
      <i [ngClass]="selectedReport === 2 ? 'fa-minus' : 'fa-plus'" class="fa"></i>
    </h3>
  </div>

  <div class="card-body" *ngIf="selectedReport === 2">
    <div class="row">
      <div class="col-sm-5">
        <div class="form-group">
          <label for="yearMonthlyComplete" class="form-label">Año:</label>

          <input
            type="number"
            [(ngModel)]="selectedYear"
            id="yearMonthlyComplete"
            name="yearMonthlyComplete"
            class="form-control"
            min="2000"
            max="2100">
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group">
          <label for="monthMonthlyComplete" class="form-label">Mes:</label>

          <select
            [(ngModel)]="selectedMonth"
            id="monthMonthlyComplete"
            name="monthMonthlyComplete"
            class="form-select">

            <option *ngFor="let month of months" [value]="month.value">
              {{ month.label }}
            </option>

          </select>
        </div>
      </div>

      <div class="col-sm-2 download-buttons">
        <button
          [disabled]="monthlyCompleteReport.excel"
          (click)="getReport('excel', monthlyCompleteReport)"
          class="btn btn-success"
          data-bs-toggle="tooltip"
          title="Descargar Excel">

          <i *ngIf="!monthlyCompleteReport.excel" class="fa fa-file-excel"></i>

          <span
            *ngIf="monthlyCompleteReport.excel"
            class="spinner-border spinner-border-sm"
            aria-hidden="true">
          </span>
        </button>
      </div>
    </div>
  </div>
</div>